import * as React from 'react';

import get from 'lodash/get';

import { createReactRenderer } from 'helpers/react-renderer';

import Router from './router';

interface Props {
  [key: string]: any;
}

interface State {
  hasSessionData: boolean;
}

export default class ReactPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      hasSessionData: !!get(window.merchantos, 'session.sessData'),
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ hasSessionData: boolean; hasModuleData: bo... Remove this comment to see the full error message
      hasModuleData: false,
    };
  }

  componentDidMount() {
    const reactPage = document.getElementById('react-page');
    if (reactPage) {
      reactPage.style.display = 'block';
    }

    if (!this.state.hasSessionData) {
      window.merchantos.session.init().done(() => {
        this.setState({
          hasSessionData: true,
        });
      });
    }

    window.lsCloud.Modules.waitForModules.done(() => {
      this.setState({
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '{ hasModuleData: boolean; }' is ... Remove this comment to see the full error message
        hasModuleData: true,
      });
    });
  }

  componentWillUnmount() {
    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
    document.getElementById('react-page').style.display = 'none';
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasModuleData' does not exist on type 'R... Remove this comment to see the full error message
    const { hasSessionData, hasModuleData } = this.state;

    return <Router loading={!hasSessionData || !hasModuleData} />;
  }
}

const RenderedComponent = createReactRenderer({
  component: ReactPage,
  selector: '[data-react-root="ReactPage"]',
});

if (window.isReactPage) {
  RenderedComponent.mount();
}

window.merchantos.asyncSubscribe.subscribeToFormCall('react.mount.page', ({ props, callback }) => {
  RenderedComponent.mount({ props, callback });
});

window.merchantos.asyncSubscribe.subscribeToFormCall('react.unmount.page', () => {
  RenderedComponent.unmount();
});
